import { useResetForm } from '@/features/pos/components/OrderFinalization/form'
import { useClearOrder } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/hooks/useClearOrder'
import { useCallback } from 'react'

export const useCancelOrderConfirm = (onClose: () => void): (() => void) => {
    const clearOrder = useClearOrder()

    const reset = useResetForm()

    return useCallback(() => {
        clearOrder()

        reset()

        onClose()
    }, [clearOrder, reset, onClose])
}
